import { render, staticRenderFns } from "./PSUCompanyUtility.vue?vue&type=template&id=02038e98&scoped=true&"
import script from "./PSUCompanyUtility.vue?vue&type=script&lang=js&"
export * from "./PSUCompanyUtility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02038e98",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
